import { Grid } from "@material-ui/core";
import React from "react";
import { BooleanInput } from "react-admin";

const AllDaysOfWeekInput = () => (
  <>
    <Grid item xs={2}>
      <BooleanInput label="Monday" source="isMonday" />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput label="Tuesday" source="isTuesday" />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput label="Wednesday" source="isWednesday" />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput label="Thursday" source="isThursday" />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput label="Friday" source="isFriday" />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput label="Saturday" source="isSaturday" />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput label="Sunday" source="isSunday" />
    </Grid>
  </>
);

export default AllDaysOfWeekInput;
